import React from 'react';

const NAV_ITEMS = [
  { id: 'dashboard',  icon: '⬡',  label: 'Dashboard'    },
  { id: 'chat',       icon: '✏️',  label: 'Nuevo'        },
  { id: 'entries',    icon: '📨',  label: 'Predicados'   },
  { id: 'contexts',   icon: '🗂️',  label: 'Contextos'    },
  { id: 'tasks',      icon: '✅',  label: 'Tareas'       },
  { id: 'risks',      icon: '⚠️',  label: 'Riesgos'      },
  { id: 'decisions',  icon: '🎯',  label: 'Decisiones'   },
  { id: 'people',     icon: '👥',  label: 'Personas'     },
  { id: 'weekly',     icon: '📅',  label: 'Esta semana'  },
];

function Sidebar({ currentView, onNavigate, apiStatus }) {
  return (
    <aside className="sidebar">
      <div className="sidebar__brand">
        <div className="sidebar__logo">⬡</div>
        <div>
          <div className="sidebar__title">CLAI</div>
          <div className="sidebar__subtitle">Chapter Lead AI</div>
          <div className="sidebar__active">• activo</div>
        </div>
      </div>

      <div className="sidebar__divider" />

      <nav className="sidebar__nav">
        {NAV_ITEMS.map(item => (
          <button
            key={item.id}
            className={`sidebar__nav-item${currentView === item.id ? ' active' : ''}`}
            onClick={() => onNavigate(item.id)}
          >
            <span className="sidebar__nav-icon">{item.icon}</span>
            <span>{item.label}</span>
          </button>
        ))}
      </nav>

      <div className="sidebar__footer">
        <div className="sidebar__divider" />
        <div className="sidebar__api-status">
          <span>api.xpertus.net</span>
          <span
            className="status-dot"
            style={{
              background: apiStatus ? 'var(--success)' : 'var(--danger)',
              boxShadow: `0 0 6px ${apiStatus ? 'var(--success)' : 'var(--danger)'}`,
            }}
          />
        </div>
        <div className="sidebar__version">v3.0.0</div>
      </div>
    </aside>
  );
}

export default Sidebar;
